// eslint-disable-next-line import/prefer-default-export
export const closeNotification = () => dispatch =>
  dispatch({
    type: 'CLOSE_NOTIFICATION',
  });

export const notifyError = dispatch => dispatch({ type: 'NOTIFICATION_SERVER_ERROR' });
export const notifyError404 = dispatch => dispatch({ type: 'NOTIFICATION_SERVER_ERROR_404' });
